import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  FaClock,
  FaFileAlt,
  FaHeadphones,
  FaCheckCircle,
  FaCoffee,
  FaEnvelope,
} from 'react-icons/fa';
import logo from '../../assets/logo.png';
import './Home.css';

export default function Home() {
  return (
    <main className="home-container">
<Helmet>
  <title>ProdPilot – Your All-in-One Productivity Toolkit</title>
  <meta
    name="description"
    content="Use ProdPilot to stay focused, build better habits, and boost productivity. Includes a Pomodoro Timer, Habit Tracker, Text Splitter for ChatGPT, and Audio Focus Player."
  />
  <meta property="og:title" content="ProdPilot – Productivity App for Focus and Habits" />
  <meta
    property="og:description"
    content="Focus smarter with a built-in Pomodoro timer, daily habit tracker, and tools to boost your consistency. Perfect for students, creators, and professionals."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://prodpilotapp.com/" />
  <meta property="og:image" content="https://prodpilotapp.com/og-image.png" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <link rel="canonical" href="https://prodpilotapp.com/" />
</Helmet>


      <header className="home-header">
        <img src={logo} alt="ProdPilot productivity app logo" className="home-logo" />
        <h1>Welcome to ProdPilot</h1>
        <p className="subtitle">
          ProdPilot is your all-in-one productivity app combining tools like a Pomodoro timer, a
          habit tracker, and a text splitter to help you focus, stay consistent, and get more done.
        </p>
      </header>

      <nav className="home-buttons">
        <Link to="/timer" className="home-btn"><FaClock /> Timer</Link>
        <Link to="/splitter" className="home-btn"><FaFileAlt /> Splitter</Link>
        <Link to="/habits" className="home-btn"><FaCheckCircle /> Habits</Link>
        <Link to="/pulse" className="home-btn"><FaHeadphones /> Pulse</Link>
      </nav>

      <section className="home-sections">
        <Link to="/timer" className="home-card-link">
          <article className="home-card">
            <FaClock className="home-icon" />
            <h2>Pomodoro Timer</h2>
            <p>
              Work in short, focused intervals with built-in breaks. Add tasks,
              track sessions, and celebrate small wins. A perfect Pomodoro timer app for deep focus.
            </p>
          </article>
        </Link>

        <Link to="/splitter" className="home-card-link">
          <article className="home-card">
            <FaFileAlt className="home-icon" />
            <h2>Text Splitter</h2>
            <p>
              Paste long transcripts or text and break them into manageable
              chunks for ChatGPT or clean formatting. Ideal for AI prompts or productivity workflows.
            </p>
          </article>
        </Link>

        <Link to="/pulse" className="home-card-link">
          <article className="home-card">
            <FaHeadphones className="home-icon" />
            <h2>Audio Pulse</h2>
            <p>
              Play ambient music or YouTube tracks with a real-time pulse
              visualizer to get in the flow. Great for deep work sessions.
            </p>
          </article>
        </Link>

        <Link to="/habits" className="home-card-link">
          <article className="home-card">
            <FaCheckCircle className="home-icon" />
            <h2>Habit Tracker</h2>
            <p>
              Build healthy routines and track your daily goals. Maintain streaks,
              stay motivated, and visualize your consistency with our habit tracker.
            </p>
          </article>
        </Link>

        <Link to="/contact" className="home-card-link">
          <article className="home-card">
            <FaEnvelope className="home-icon" />
            <h2>Suggestions / Contact</h2>
            <p>
              Have feedback or an idea? Let us know! Send a quick message and help
              make ProdPilot even better.
            </p>
          </article>
        </Link>

        <article className="home-card support-card">
          <FaCoffee className="home-icon" />
          <h2>Support the Creator</h2>
          <p>
            This app was built to stay organized and help others do
            the same. If ProdPilot helps you, consider{' '}
            <a
              href="https://buymeacoffee.com/prodpilot"
              target="_blank"
              rel="noopener noreferrer"
            >
              buying me a coffee
            </a>{' '}
            to support updates.
          </p>
        </article>
      </section>
    </main>
  );
}
